/* We use parseAlgoliaHitHighlight() from @algolia/autocomplete-preset-algolia
  There's a limitation of this function, that it only parses the highlight for following
  highlightPreTag and highlightPostTag. Hence we are passing same as arguments when fetching search results.
*/
export const HIGHLIGHT_PRE_TAG = '__aa-highlight__';
export const HIGHLIGHT_POST_TAG = '__/aa-highlight__';
export const SEARCH_INDEX_NAME = 'marketplace_plugins_prod_query_suggestions';

// source: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/state
export const AutoCompleteStatusValues = {
  IDLE: 'idle',
  LOADING: 'loading',
  STALLED: 'stalled',
  ERROR: 'error'
};
export const desktopPlaceholder = 'Type your search query here';
export const mobilePlaceholder = 'Search Marketplace';